import React from 'react';
import { ReactComponent as FigPlusComponent } from './FigPlus.svg';

const FigPlus = (props) => <FigPlusComponent {...props} />;

export default FigPlus;
